import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../../../api";
import DynamicBreadcrumb from "../../include/DynamicBreadcrumb";

const DynamicBanner = () => {
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ detect mobile properly
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/banner");
        const data = response.data;

        if (data && data.banner_data) {
          setBannerData(data.banner_data);
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  if (loading) return <></>;
  if (!bannerData) return <></>;

  const {
    images = [],
    mobile_images = [],
    buttons = [],
    heading = ""
  } = bannerData;

  // ✅ only ONE set loads (desktop OR mobile)
  const bannerImages =
    isMobile && mobile_images.length > 0
      ? mobile_images
      : images;

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="alumni_banner">
      <section className="breadcrump_section">
        <Slider {...sliderSettings} className="banner-slider">
          {bannerImages.map((img, index) => (
            <div key={index} className="banner-slider">
              <img
                src={
                  img.startsWith("http")
                    ? img
                    : `${process.env.REACT_APP_API_URL}/public/${img}`
                }
                alt={`Banner ${index + 1}`}
                className="img-fluid"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </Slider>
        <DynamicBreadcrumb/>

        <div className="breadcrump-wrapper">
          <h1 className="breadcrump-heading">{heading}</h1>
          <div className="d-flex justify-content-center flex-wrap gap-3 mt-3">
            {buttons.map((btn, idx) => (
              <Link
                to={btn.link}
                key={idx}
                className="btn apply-new-btn"
                target={btn.target || "_self"}
                rel="noopener noreferrer"
              >
                {btn.text}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DynamicBanner;
